<template>
  <li class="item"
      :class="itemStyles">
    <icon :link="item.details.url"
          :event="item.event_name" />

    <div class="item-info">
      <div class="item-info-url">
        <a class="link" :href="item.details.url">
          {{ getDomain(item.details.url) }}
        </a>

        <div v-if="item.event_name === 'block'" class="category">
          {{ $t("blocked", { categories }) }}
        </div>

        <div v-if="item.event_name === 'warn'" class="category">
          {{ $t("viewed", { categories }) }}
        </div>
      </div>

      <div v-if="device"
           class="item-info-device">
        {{ device.name }}
      </div>

      <div v-if="isToday(item.time)" class="item-info-time">
        {{ item.time | timeAgo }}
      </div>

      <div v-else class="item-info-time">
        {{ item.time | localTime }}
      </div>
    </div>

    <div class="icon-gear" ref="iconGear">
      <icon-gear width="16"
                 height="16"
                 iconColor="#9e9c9d"  />
      <div class="url-options" ref="urlOptions">
        <div class="option option-allow"
             @click="onAllowClick(item.details.url)">
          <icon-thumbs-up width="18"
                          height="18"
                          iconColor="#22c883" />
          {{ $t("alwaysAllow") }}
        </div>

        <div class="option option-block"
             @click="onBlockClick(item.details.url)">
          <icon-block width="18"
                      height="18"
                      iconColor="#f35f5f" />
          {{ $t("alwaysBlock") }}
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import Icon from './BlocksAndAlertsIcon.vue'
  import getCategories from '@/services/categories.js'
  import { getDomain } from '@/services/utils.js'
  import { isToday } from '@/services/intl'
  import analytics from '@/services/analytics.js'
  import tippy from 'tippy.js'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      }
    },

    components: {
      Icon
    },

    mounted() {
      this.initUrlOptionsPicker()
    },

    methods: {
      initUrlOptionsPicker() {
        tippy(this.$refs.iconGear,  {
          allowHTML: true,
          content: this.$refs.urlOptions,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: false,
          inertia: true,
          duration: [400, 300]
        })
      },

      onAllowClick(url) {
        analytics.sendEvent('Pk_Alrt_BlkAlrtRpt')

        this.$emit('allowUrl', {
          url: url,
          mode: 'allow'
        })

        this.$refs.iconGear._tippy.hide()
      },

      onBlockClick(url) {
        analytics.sendEvent('Pk_Blk_BlkAlrtRpt')

        this.$emit('blockUrl' ,{
          url: url,
          mode: 'block'
        })

        this.$refs.iconGear._tippy.hide()
      },

      getDomain(url) {
        return getDomain(url)
      },

      isToday
    },

    computed: {
      child() {
        return this.getChildById(this.item.user_id)
      },

      device() {
        return this.child.devices.find(device => device.id === this.item.device_id)
      },

      categories() {
        return getCategories(
          this.item.details.category_ids,
          this.commonCategories,
          this.customCategories
        )
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('categories', {
        commonCategories: 'get',
        customCategories: 'getCustom'
      }),

      itemStyles() {
        return {
          'item-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    width: 100%;
    height: 64px;
    display: flex;
    border-top: 1px solid #f2f2f2;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px 0 0;

    &-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-url {
        width: 50%;

        .link {
          display: inline-flex;
          max-width: 450px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: map.get($colors, primary);
        }

        .category {
          color: #3e3a3b;
          font-size: 14px;
          opacity: .5;
        }
      }

      &-device {
        width: 30%;
        text-align: right;
        color: rgba(#3e3a3b, .7);
      }

      &-time {
        width: 20%;
        text-align: right;
        color: rgba(#3e3a3b, .7);
      }
    }

    .icon-settings {
      opacity: 0;
    }

    &:hover {
      .icon-settings {
        opacity: 1;
      }
    }

    &:last-child {
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .icon-gear {
    margin-left: 32px;
    cursor: pointer;
  }

  .url-options {
    width: 150px;

    .option {
      height: 45px;
      font-size: 16px;
      padding: 16px 12px;
      cursor: pointer;

      &:hover {
        background: color.adjust(map.get($colors, primary), $lightness: 40%);
      }

      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .option-allow {
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .item-mobile {
    height: auto;

    .item-info {
      flex-wrap: wrap;
      justify-content: flex-start;

      .item-info-url {
        width: 100%;
        flex: unset;
      }

      .item-info-device {
        padding-right: 20px;
      }

      .item-info-device,
      .item-info-time {
        flex: unset;
        width: auto;
        text-align: center;
        font-size: 12px;
        padding-top: 5px;
        color: #3e3a3b;
        opacity: .5;
      }
    }
  }
</style>
